import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=65f4c844&scoped=true&"
import script from "./detailed.vue?vue&type=script&lang=js&"
export * from "./detailed.vue?vue&type=script&lang=js&"
import style0 from "./detailed.vue?vue&type=style&index=0&id=65f4c844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f4c844",
  null
  
)

export default component.exports